import React from "react";
import Grid from '@mui/material/Grid';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import './style.scss'
import {FormControl, FormHelperText} from "@mui/material";

export default (data, key) => {
    return (<Grid item md={6} xs={12} key={key}>
        <FormControl fullWidth key={key} error={data.error ? true : false}>

        <PhoneInput country={'us'}
            required={data?.inputProps?.required ?  true : false}
            margin="normal"
            fullWidth
            error={data.error ? true : false}
            helperText={data.error}
            className={data.error ? 'error-red' : ''}
            inputProps={data.inputProps || {}}
            id={`${data.name}-${key}`}
            label={data.headerName}
            value={data.value}
            name={data.name}
            onChange={(e) => data.onCallback({target:{name:data.name, value: e}})}
        />
            {data.error && (<FormHelperText>{data.error}</FormHelperText>)}
        </FormControl>
    </Grid>)
}